export enum EmbedUrlIndentifier {
  EXECUTOR_WELCOME_VIDEO = 'executor_welcome_video',
  DUTIES_OF_EXECUTOR_VIDEO = 'duties_of_executor_video',
  DUTIES_OF_EXECUTOR_GOOGLE_SLIDE = 'duties_of_executor_google_slide',
  CLEARESTATE_COMES_IN_VIDEO = 'clearestate_comes_in_video',
  CLEARESTATE_COMES_IN_GOOGLE_SLIDE = 'clearestate_comes_in_google_slide',
  ASSESS_VIDEO = 'assess_video',
  ASSESS_GOOGLE_SLIDE = 'assess_google_slide',
  NAVIGATING_CLIENT_ESTATE_DASHBOARD_VIDEO = 'navigating_client_estate_dashboard_video',
  ADVISOR_PRO_INTRO_VIDEO = 'advisor_pro_intro_video',
  CONQUEST_PLAN_DATA_SUMMARY_VIDEO = 'conquest_plan_data_summary_video'
}
